export default __webpack_public_path__ + "static/media/elf.92b3aa78.png";